import { createContext, useContext } from 'react'

import { flattenNavItems, type NavItem } from './navigation'

/** Item do menu da rota atual, para o cabeçalho de página reaproveitar o ícone. */
export const CurrentNavContext = createContext<NavItem | undefined>(undefined)

export function useCurrentNavItem(): NavItem | undefined {
  return useContext(CurrentNavContext)
}

/** Escolhe a página do menu (subitens incluídos) cuja rota é a mais específica para o caminho atual. */
export function findCurrentNavItem(items: NavItem[], pathname: string): NavItem | undefined {
  const matches = flattenNavItems(items).filter((item) =>
    item.exact ? pathname === item.to : pathname === item.to || pathname.startsWith(`${item.to}/`),
  )

  return matches.sort((a, b) => b.to.length - a.to.length)[0]
}
